import { JobPositionInfoCard, Loading } from "@cpj-ai/panel-npm-package";
import { useGetJobPositionsQuery } from "@graphql/generated";
import { useParams } from "react-router-dom";

const JobDetailTabContent = () => {
  const { id } = useParams();

  const { data, loading } = useGetJobPositionsQuery({
    variables: {
      id: id || "",
    },
    skip: !id,
  });

  const jobPosition = data?.admin?.jobPositions?.edges[0]?.node;

  if (loading) return <Loading />;

  return <JobPositionInfoCard jobPosition={jobPosition} />;
};

export default JobDetailTabContent;
